import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import { inwardSubTypes, listEwayHeads, mode, outwardSubTypes, transTypes } from './data';
import { useThemes } from '../../../components/Theme/theme';
import { useState } from 'react';
import EWayExtend from '../../../components/modals/ewayExtend';
import moment from 'moment';
import dayjs from 'dayjs';
import { useGetCodeTranslationQuery } from '../../../redux/apis/getCodeTranslation.api';
import { useNavigate } from 'react-router-dom';

const DataTable = ({ data, ourDatabase, setData, setBackdropOpen, storage }) => {
  const [extendModalOpen, setExtendModalOpen] = useState(false);
  const [extendData, setExtendData] = useState({});
  const { theme } = useThemes();
  console.log(data, 'data');
  const navigate = useNavigate();
  const { data: stateList, isSuccess: stateListSuc } = useGetCodeTranslationQuery({ codetype: 'IndiaState' });
  function checkIfExpired(dateStr) {
    // Convert "30/03/2025 11:59:00 PM" to a Date object
    if (dateStr) {
      const [datePart, timePart, meridian] = dateStr?.split(' ');
      const [day, month, year] = datePart?.split('/');
      // Build a proper ISO string to pass to Date constructor
      const formatted = `${year}-${month}-${day} ${timePart} ${meridian}`;

      const inputDate = new Date(formatted);
      const now = new Date();

      return inputDate < now ? 'Expired' : 'Active';
    } else {
      return '';
    }
  }
  function isWithinEightHours(dateStr) {
    // Parse input: "dd/mm/yyyy hh:mm:ss AM/PM"
    if (dateStr) {
      const [datePart, timePart, meridian] = dateStr?.split(' ');
      const [day, month, year] = datePart?.split('/');

      const formatted = `${year}-${month}-${day} ${timePart} ${meridian}`;
      const inputDate = new Date(formatted);

      const now = new Date();

      // 8 hours in milliseconds
      const eightHours = 8 * 60 * 60 * 1000;

      const lowerBound = new Date(now.getTime() - eightHours);
      const upperBound = new Date(now.getTime() + eightHours);

      return inputDate >= lowerBound && inputDate <= upperBound;
    } else {
      return '';
    }
  }
  return (
    <TableContainer sx={{ marginTop: 3 }}>
      <Table
        stickyHeader
        aria-label="sticky table"
        sx={{
          borderRadius: 2,
        }}
      >
        <TableHead>
          <TableRow>
            {listEwayHeads.map((data) => (
              <TableCell
                align={data.align}
                sx={{
                  color: '#FFF',
                  backgroundColor: 'primary.main',

                  fontWeight: 'bold',
                  minWidth: data.width,
                  lineHeight: 1,
                  padding: '3px',
                  paddingLeft: data.id === 'sl' ? '20px' : '3px',
                  paddingRight: data.id === 'dist' ? '20px' : '3px',
                }}
              >
                {data.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data && data?.length > 0 ? (
            data.map((dat, i) => {
              const status = (
                dat?.value?.rejectStatus === 'Y' ? 'Rejected' : dat?.value?.rejectStatus === 'N' && dat?.value?.status === 'CNL'
              )
                ? 'Cancelled'
                : checkIfExpired(dat?.value.validUpto)
                ? checkIfExpired(dat?.value.validUpto)
                : 'Active';

              const extendBtn = isWithinEightHours(dat?.value.validUpto);
              const types = dat.value.supplyType === 'O' ? outwardSubTypes : inwardSubTypes;
              const subType = types.filter((dd) => dd.value === dat.value.subSupplyType.trim());
              const partyState = stateList?.filter((state) => state.statecode == dat.value.toStateCode)[0].codetext;
              const transactionType = transTypes.filter((tt) => tt.value == dat.value.transactionType)[0].label;
              const transMode =
                dat.value.VehiclListDetails && dat.value.VehiclListDetails.length > 0
                  ? mode.filter((mm) => mm.value == dat.value.VehiclListDetails[0]?.transMode)[0]?.label
                  : ' ';
              // console.log(dat.value.VehiclListDetails[0].transMode, "dat.value");
              console.log(dat, 'ppppppppppppp');

              return (
                <TableRow
                  // onClick={() => {
                  //   navigate("/addewaybill", {
                  //     state: { data: dat.value, status },
                  //   });
                  //   localStorage.setItem(
                  //     "singleOthewayData",
                  //     JSON.stringify(storage)
                  //   );
                  // }}
                  sx={{ cursor: 'pointer', padding: '5px' }}
                >
                  <TableCell align="left" sx={{ padding: '5px 15px' }}>
                    {i + 1}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {dat.value.ewbNo}
                  </TableCell>
                  <TableCell align="left" sx={{ maxWidth: '100px', padding: '5px' }}>
                    <Tooltip
                      title={dayjs(dat?.value.ewayBillDate, 'DD/MM/YYYY hh:mm:ss A').format('DD/MMM/YYYY hh:mm:ss A')}
                      placement="right"
                    >
                      <span
                        style={{
                          display: 'block',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {/* {} */}
                        {dayjs(dat?.value.ewayBillDate, 'DD/MM/YYYY hh:mm:ss A').format('DD/MMM/YYYY hh:mm:ss A')}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="left" sx={{ maxWidth: '100px', padding: '5px' }}>
                    <Tooltip title={dayjs(dat.value.validUpto, 'DD/MM/YYYY hh:mm:ss A').format('DD/MMM/YYYY hh:mm:ss A')} placement="right">
                      <span
                        style={{
                          display: 'block',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {dayjs(dat.value.validUpto, 'DD/MM/YYYY hh:mm:ss A').format('DD/MMM/YYYY hh:mm:ss A')}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {extendBtn === true ? (
                      <Button
                        sx={{
                          backgroundColor: 'green',
                          color: 'white',
                          fontWeight: 'bold',
                          fontSize: '12px',
                          '&:hover': {
                            backgroundColor: 'green',
                          },
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setExtendData({
                            ewbNo: dat.value.ewbNo,
                            vehicleNo: 'KL459369',
                            fromPlace: dat.value.delPlace,
                            fromState: dat.value.delStateCode,
                            fromPincode: dat.value.delPinCode,
                          });
                          setExtendModalOpen(true);
                        }}
                      >
                        Extend
                      </Button>
                    ) : (
                      <Typography
                        variant="p"
                        sx={{
                          color: status === 'Expired' ? '#ca430fde' : status === 'Cancelled' || status === 'Rejected' ? 'red' : 'green',
                        }}
                      >
                        {status}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {dat.value.supplyType === 'O' ? 'Outward' : 'Inward'}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {subType[0].label}
                  </TableCell>
                  <TableCell align="left" sx={{ maxWidth: '150px', padding: '5px' }}>
                    <Tooltip title={dat.value.fromTrdName} placement="right">
                      <span
                        style={{
                          display: 'block',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {dat.value.fromTrdName}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {dat.value.toGstin}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {partyState}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {dat.value.toPincode}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {transactionType}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {transMode}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {dat.value.itemList.length}
                  </TableCell>
                  <TableCell align="left" sx={{ maxWidth: '150px', padding: '5px' }}>
                    <Tooltip title={dat.value.transporterName} placement="right">
                      <span
                        style={{
                          display: 'block',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {dat.value.transporterName}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {dat.value.transporterId}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {dat.value.VehiclListDetails[0]?.vehicleNo ? dat.value.VehiclListDetails[0]?.vehicleNo : ' '}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {dat.value?.docNo ? dat.value?.docNo : ' '}
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px' }}>
                    {dat.value?.docDate ? dayjs(dat.value?.docDate, 'DD/MM/YYYY').format('DD/MMM/YYYY') : ' '}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '5px' }}>
                    {dat.value.totalValue}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '5px' }}>
                    {dat.value.cgstValue + dat.value.igstValue + dat.value.sgstValue + dat.value.cessValue}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '5px' }}>
                    {dat.value.totInvValue}
                  </TableCell>
                  <TableCell align="right" sx={{ padding: '5px 20px' }}>
                    {dat.value.actualDist}
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell height={'400'} align="center" colSpan={9} sx={{ border: 'none' }}>
                No Data Found
              </TableCell>
            </TableRow>
          )}
          {/* {ourDatabase && ourDatabase?.length > 0 ? (
            ourDatabase.map((dat, i) => {
              console.log(dat, 'dat');
              const status = checkIfExpired(dayjs(dat.validupto).format('DD/MM/YYYY hh:mm:ss A'));

              const extendBtn = isWithinEightHours(dayjs(dat.validupto).format('DD/MM/YYYY hh:mm:ss A'));
              // const test =
              // console.log(test, "tets");
              const types = dat.supplytype === 'O' ? outwardSubTypes : inwardSubTypes;

              const transType = transTypes.filter((tt) => tt.value === dat.transactiontype)[0].label;
              return (
                <TableRow>
                  <TableCell align="left">{i + 1}</TableCell>
                  <TableCell align="left">{dat.ewaybillno}</TableCell>
                  <TableCell align="left">{dayjs.unix(dat.ewaybilldate).format('DD/MM/YYYY hh:mm:ss A')}</TableCell>
                  <TableCell align="left">{dayjs.unix(dat.validupto).format('DD/MM/YYYY hh:mm:ss A')}</TableCell>
                  <TableCell align="left">
                    {extendBtn === true ? (
                      <Button
                        sx={{
                          backgroundColor: '#cf1e1e',
                          color: 'white',
                          fontWeight: 'bold',
                          fontSize: '12px',
                          '&:hover': {
                            backgroundColor: '#cf1e1e',
                          },
                        }}
                        onClick={() => {
                          setExtendModalOpen(true);
                        }}
                      >
                        Extend
                      </Button>
                    ) : (
                      status
                    )}
                  </TableCell>
                  <TableCell align="left">{dat.supplytype === 'O' ? 'Outward' : 'Inward'}</TableCell>
                  <TableCell align="left">{types.filter((dd) => dd.value === dat.subtype)[0]?.label}</TableCell>
                  <TableCell align="left">{dat.fromtradename}</TableCell>
                  <TableCell align="left">{dat.partygstin}</TableCell>
                  <TableCell align="left">{dat.billingstate}</TableCell>
                  <TableCell align="left">{dat.billingpincode}</TableCell>
                  <TableCell align="left">{transType}</TableCell>

                  <TableCell align="left">{mode.filter((dd) => dd.value === dat.modeoftransport)[0]?.label}</TableCell>
                  <TableCell align="left">{dat.total_items_count}</TableCell>
                  <TableCell align="left">{dat.transportername}</TableCell>
                  <TableCell align="left">{dat.transporterid ? dat.transporterid : ''}</TableCell>
                  <TableCell align="left">{dat.vehicleno}</TableCell>
                  <TableCell align="left">{dat.invoiceno}</TableCell>

                  <TableCell align="left">
                    {dayjs(dat.invoicedate * 1000).format('DD/MM/YYYY') === '01/01/1970'
                      ? ''
                      : dayjs(dat.invoicedate * 1000).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell align="right">{dat.totalitemamount}</TableCell>
                  <TableCell align="right">{dat.gstamount + dat.cessamount}</TableCell>
                  <TableCell align="right">{dat.totalinvoiceamount}</TableCell>
                  <TableCell align="left">{dat.distance ? dat.distance : ''}</TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell height={'400'} align="center" colSpan={9} sx={{ border: 'none' }}>
                No Data Found
              </TableCell>
            </TableRow>
          )} */}
        </TableBody>
      </Table>
      {extendModalOpen === true && (
        <EWayExtend
          extendData={extendData}
          setData={setData}
          open={extendModalOpen}
          setOpen={setExtendModalOpen}
          title="Provide details to Extend"
          // setBackdropOpen={setBackdropOpen}
        />
      )}
    </TableContainer>
  );
};
export default DataTable;
